import { render, staticRenderFns } from "./editContactUs.vue?vue&type=template&id=21486e80&scoped=true&"
import script from "./editContactUs.vue?vue&type=script&lang=js&"
export * from "./editContactUs.vue?vue&type=script&lang=js&"
import style0 from "./editContactUs.vue?vue&type=style&index=0&id=21486e80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21486e80",
  null
  
)

export default component.exports